export default {
  title: {
    historyList: "History List",
    keySteps: "Key Steps",
  },
  buttons: {
    historyList: "History List",
    keySteps: "Key Steps",
  },
};
